import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import env from "./env";

export default class SecurityService {
  constructor($http, $localStorage, $state, EnvService, $rootScope, $httpParamSerializerJQLike) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.$env = EnvService;
    this.$rootScope = $rootScope;
    this.createRecipientUrl = "jbl/v1/stripe/create-recipient-stripe-account?format=json&conf=web&typeAccount=individual";
    this.current_event = null;
  }

  redirect(state) {
    url = url || "/";
    this.$state.go(state);
  }

  isUndefinedOrNull(val) {
    return angular.isUndefined(val) || val === null || val === "";
  }

  isThisEventLive(shiftsArray) {
    var retObj = {};

    console.log("what is shifts array");
    console.dir(shiftsArray);

    retObj.checkInTime = null;
    retObj.checkOutTime = null;
    retObj.checkInLat = null;
    retObj.checkInLng = null;
    retObj.checkOutLat = null;
    retObj.contactInfo = null;
    retObj.checkOutLng = null;
    retObj.eventIsLive = false;

    shiftsArray.sort(function (a, b) {
      return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
    });

    shiftsArray.forEach(function (s, i) {
      retObj.contactInfo = s.contactInfo;
      var index = i + 1;
      var st = moment(s.timeInterval.startTime).subtract(15, "minutes");
      var et;
      if (index === shiftsArray.length) {
        var indexLast = index - 1;
        et = moment(shiftsArray[indexLast].timeInterval.endTime).add(8000, "hours");
      } else {
        et = moment(shiftsArray[index].timeInterval.startTime).subtract(15, "minutes");
      }
      if (moment().isAfter(st) && moment().isBefore(et)) {
        retObj.shiftId = s.id;

        retObj.eventIsLive = true;

        if (s.checkInTime !== null) {
          retObj.checkInTime = s.checkInTime;
          if (s.checkInCoord) {
            retObj.checkInLat = s.checkInCoord.lat;
            retObj.checkInLng = s.checkInCoord.lng;
          }
        }

        if (s.checkOutTime !== null) {
          console.log("what is this before it breaks");
          console.dir(s);

          retObj.checkOutTime = s.checkOutTime;
          if (s.checkOutCoord) {
            retObj.checkOutLat = s.checkOutCoord.lat;
            retObj.checkOutLng = s.checkOutCoord.lng;
          }
        }
      }
      /*
            if (i === 0) {
                if (moment().isAfter(st)) {
                    retObj.eventIsLive = true;
                }
            }
            */
    });

    return retObj;
  }

  getJobblersPicture(size, jobbler) {
    var correctPicture = "";
    if (!this.isUndefinedOrNull(jobbler.picture1s)) {
      try {
        var pic1found = false;
        jobbler.picture1s.forEach(function (pic) {
          if (pic.indexOf(size) > -1) {
            correctPicture = pic;
            pic1found = true;
          }
        });
      } finally {
        if (pic1found === false) {
          if (!this.isUndefinedOrNull(jobbler.picture1)) {
            correctPicture = jobbler.picture1;
          } else {
            correctPicture = jobbler.profilePictureUri;
          }
        }
      }
    } else {
      if (!this.isUndefinedOrNull(jobbler.picture1)) {
        correctPicture = jobbler.picture1;
      } else {
        correctPicture = jobbler.profilePictureUri;
      }
    }

    return correctPicture;
  }

  calculateTheTime(minutes) {
    var timeObj = {};
    var minutesDivided = minutes / 60;
    var minutesStr = minutesDivided.toString();
    var index = minutesStr.indexOf(".");
    var length = minutesStr.length;
    var finalStr = minutesStr.substring(index, length);
    var hourStr = minutesStr.substring(0, index);
    var backToFloat = parseFloat(finalStr);
    var minutesTimes = backToFloat * 60;
    timeObj.hours = parseInt(hourStr, 10);
    timeObj.minutes = minutesTimes;
    return timeObj;
  }

  hireJobblerAfterConnection(jobblesAndApplicants) {
    var _this = this;

    var hireJobblersData = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-accept?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {
        jobblesAndApplicants: jobblesAndApplicants,
      },
    };

    return _this.$http(hireJobblersData);
  }

  getUser(id) {
    var _this = this;

    var user = {
      method: "GET",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + id,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(user);
  }

  getApplicationInfoTrimmedv2(application) {
    var _this = this;

    var picparam = "";

    picparam = "applicant.picture1s";

    var user = {
      method: "GET",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/applications/" +
        application.id +
        "?format=json&fields=id,applicant.firstName,applicant.nickname,applicant.lastName,applicant.bio,applicant.averageRatingReceived,applicant.profilePictureUri,applicant.profilePictureUriFree,applicant.numberOfCompletedJobbles,applicant.id,applicant.email,applicant.honorsAndAwards,applicant.homeContactInfo.phoneMobile,applicant.homeContactInfo.streetLine1,applicant.homeContactInfo.zipCode,applicant.homeContactInfo.city,applicant.homeContactInfo.state",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(user);
  }

  getApplicationInfoTrimmed(application) {
    var _this = this;

    var picparam = "";

    picparam = "applicant.picture1s";

    var user = {
      method: "GET",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/applications/" +
        application.id +
        "?format=json&fields=id,applicant.firstName,applicant.nickname,applicant.education,applicant.resumeLink,applicant.lastName,jobble.id,jobble.event.id,applicant.dateBirth,spiel,applicant.bio,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_160x160,applicant.filePROFILE_IMAGE1IMG_600x600,applicant.filePROFILE_IMAGE2IMG_600x600,applicant.filePROFILE_IMAGE3IMG_600x600,applicant.filePROFILE_IMAGE4IMG_600x600,applicant.filePROFILE_IMAGE5IMG_600x600,applicant.filePROFILE_IMAGE6IMG_600x600,applicant.numberOfCompletedJobbles,applicant.brands,applicant.certifications,applicant.id,jobbler.applicant.education,applicant.gender,jobble.id,jobble.isSourcingPost,applicant.shirtSize,applicant.twitter,applicant.facebook,applicant.profilePictureUri,applicant.instagram,applicant.googlePlus,applicant.linkdedIn,applicant.email,surveyResponses,applicant.hasDriverLicense,applicant.isVeteran,applicant.hasCar,applicant.primaryLangues,applicant.primaryLanguage,applicant.otherLanguages,applicant.honorsAndAwards,applicant.workTypes,applicant.homeContactInfo.phoneMobile,applicant.homeContactInfo.streetLine1,applicant.homeContactInfo.zipCode,applicant.homeContactInfo.city,applicant.homeContactInfo.state",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(user);
  }

  getJobblerData(jobbler, type, action, photoUrl, index, pendingApplicantsLength, acceptedApplicantsLength, rawApplication) {
    console.log("getting jobbler data");
    console.dir(jobbler);
    console.dir(rawApplication);

    var _this = this;

    var data = {};

    if (type === "default") {
      if (
        _this.$localStorage.logged_user.username.indexOf("jobble.com") !== -1 ||
        _this.$localStorage.logged_user.username.indexOf("jobbleapp.com") !== -1
      ) {
        data.name = jobbler.applicant.firstName + " " + jobbler.applicant.lastName;
      } else {
        data.name = jobbler.applicant.firstName + " " + jobbler.applicant.lastName.substring(0, 1) + ".";
      }

      if (jobbler.nickname) {
        data.nickname = jobbler.nickname;
      }

      if (index + 1 === pendingApplicantsLength) {
        data.showLink = false;
      } else {
        data.showLink = true;
      }

      if (index === 0) {
        data.showLinkPrevious = false;
      } else {
        data.showLinkPrevious = true;
      }
    }

    if (type === "hired") {
      data.isHired = true;
      data.name = jobbler.applicant.firstName + " " + jobbler.applicant.lastName;
      if (index + 1 === acceptedApplicantsLength) {
        data.showLink = false;
      } else {
        data.showLink = true;
      }

      if (index === 0) {
        data.showLinkPrevious = false;
      } else {
        data.showLinkPrevious = true;
      }
    }

    data.firstName = jobbler.applicant.firstName;
    data.lastName = jobbler.applicant.lastName;
    data.pics = [];
    data.applicationId = jobbler.id;
    data.age = moment().diff(moment(jobbler.applicant.dateBirth), "years");

    if (isNaN(data.age)) {
      data.age = null;
    }

    data.whyMe = jobbler.spiel;
    data.bio = jobbler.applicant.bio;
    data.average = Math.ceil(jobbler.applicant.averageRatingReceived);

    if (data.average === 0) {
      data.average = 1;
    }

    data.completed = jobbler.applicant.numberOfCompletedJobbles;
    data.brands = jobbler.applicant.brands;
    data.certs = jobbler.applicant.certifications;
    data.jobblerId = jobbler.applicant.id;
    data.education = jobbler.applicant.education;
    data.gender = jobbler.applicant.gender;
    //data.jobbleId = jobbler.jobble.id;
    //data.isSourcingPost = jobbler.jobble.isSourcingPost;
    data.shirtSize = jobbler.applicant.shirtSize;
    data.twitter = jobbler.applicant.twitter;
    data.facebook = jobbler.applicant.facebook;
    data.fallBackPicture = jobbler.applicant.profilePictureUri;
    data.instagram = jobbler.applicant.instagram;
    data.googlePlus = jobbler.applicant.googlePlus;
    data.linkedIn = jobbler.applicant.linkdedIn;
    data.email = jobbler.applicant.email;
    data.modalType = type;
    //data.surveyQuestions = jobbler.surveyResponses;
    data.applicationStatus = rawApplication.applicationStatus;

    if (jobbler.applicant.hasDriverLicense) {
      data.hasDriverLicense = "Yes";
    } else {
      if (jobbler.applicant.hasDriverLicense === null) {
        data.hasDriverLicense = "Not provided.";
      } else {
        data.hasDriverLicense = "No";
      }
    }
    if (jobbler.applicant.isVeteran) {
      data.isVeteran = "Yes";
    } else {
      if (jobbler.applicant.isVeteran === null) {
        data.isVeteran = "Not provided.";
      } else {
        data.isVeteran = "No";
      }
    }

    if (jobbler.applicant.hasCar) {
      data.hasCar = "Yes";
    } else {
      if (jobbler.applicant.hasCar === null) {
        data.hasCar = "Not provided.";
      } else {
        data.hasCar = "No";
      }
    }

    if (rawApplication.whyWasJobblerRemovedFromJob) {
      data.whyWasJobblerRemovedFromJob = rawApplication.whyWasJobblerRemovedFromJob;
    }

    data.primaryLanguage = jobbler.applicant.primaryLanguage;
    data.otherLanguages = jobbler.applicant.otherLanguages;
    data.honorsAndAwards = jobbler.applicant.honorsAndAwards;
    data.workTypes = jobbler.applicant.workTypes;
    data.resume = jobbler.applicant.resumeLink;
    data.photo = jobbler.applicant.filePROFILE_IMAGE1IMG_160x160;

    if (jobbler.applicant.homeContactInfo) {
      if (jobbler.applicant.homeContactInfo.phoneMobile) {
        var numStr = jobbler.applicant.homeContactInfo.phoneMobile.toString();
        numStr = numStr.replace(/[^A-Za-z0-9]/g, "");
        if (numStr.length > 10) {
          numStr = numStr.substring(1, 11);
        }
        var re = /\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})/g;
        var subst = "$1-$2-$3";
        var result = numStr.replace(re, subst);
        data.number = result;
        data.numberOrig = jobbler.applicant.homeContactInfo.phoneMobile;
      }

      data.street = jobbler.applicant.homeContactInfo.streetLine1;

      if (jobbler.applicant.homeContactInfo.city) {
        data.location =
          jobbler.applicant.homeContactInfo.city + " " + jobbler.applicant.homeContactInfo.state + ", " + jobbler.applicant.homeContactInfo.zipCode;
      } else {
        data.location = "N/A";
      }
    }

    if (jobbler.applicant.filePROFILE_IMAGE1IMG_600x600) {
      data.pics.push(jobbler.applicant.filePROFILE_IMAGE1IMG_600x600);
    }

    if (jobbler.applicant.filePROFILE_IMAGE2IMG_600x600) {
      data.pics.push(jobbler.applicant.filePROFILE_IMAGE2IMG_600x600);
    }

    if (jobbler.applicant.filePROFILE_IMAGE3IMG_600x600) {
      data.pics.push(jobbler.applicant.filePROFILE_IMAGE3IMG_600x600);
    }

    if (jobbler.applicant.filePROFILE_IMAGE4IMG_600x600) {
      data.pics.push(jobbler.applicant.filePROFILE_IMAGE4IMG_600x600);
    }

    if (jobbler.applicant.filePROFILE_IMAGE5IMG_600x600) {
      data.pics.push(jobbler.applicant.filePROFILE_IMAGE5IMG_600x600);
    }

    if (jobbler.applicant.filePROFILE_IMAGE6IMG_600x600) {
      data.pics.push(jobbler.applicant.filePROFILE_IMAGE6IMG_600x600);
    }

    return data;
  }

  getRatings(id, offset) {
    var req = {
      method: "GET",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        id +
        "/ratings/received?format=json&conf=web&sort=dateCreated&order=desc&max=5&offset=" +
        offset,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return this.$http(req);
  }

  getEventShiftTimezoneInfo(shift) {
    var zipCode = shift.contactInfo.zipCode;

    if (!this.isUndefinedOrNull(zipCode) && zipCode.length > 5) {
      zipCode = zipCode.substring(0, 5);
    }

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "public/places?format=json&conf=web&withTz=true&countryIsoCode=US&zipCode=" + zipCode,
      headers: {},
      data: {},
    };

    return this.$http(req);
  }

  displayTimeWithZone(time, time_zone_id) {
    var _this = this;

    return moment(time).tz(time_zone_id).format("hh:mm A");
  }

  getTimesFromZone(applications, roster_page) {
    var _this = this;

    var tempTimeArray = [];

    var tempTimeObj = null;

    if (roster_page) {
      try {
        applications.forEach(function (application) {
          tempTimeObj = {};

          if (application.currentShift.managerCheckInTime) {
            tempTimeObj.start_time = moment(application.currentShift.managerCheckInTime)
              .tz(application.currentShift.contactInfo.place.timeZoneId)
              .format("hh:mm A");
          }

          if (application.currentShift.managerCheckOutTime) {
            tempTimeObj.end_time = moment(application.currentShift.managerCheckOutTime)
              .tz(application.currentShift.contactInfo.place.timeZoneId)
              .format("hh:mm A");
          }

          application.currentShift.checkInAndOutForDisplay = tempTimeObj;
        });
      } finally {
        return applications;
      }
    } else {
      try {
        applications.forEach(function (application) {
          tempTimeObj = {};

          if (application.currentShift.checkInTime) {
            tempTimeObj.start_time = moment(application.currentShift.checkInTime)
              .tz(application.currentShift.contactInfo.place.timeZoneId)
              .format("hh:mm A");
          }

          if (application.currentShift.checkOutTime) {
            tempTimeObj.end_time = moment(application.currentShift.checkOutTime)
              .tz(application.currentShift.contactInfo.place.timeZoneId)
              .format("hh:mm A");
          }

          application.currentShift.checkInAndOutForDisplay = tempTimeObj;
        });
      } finally {
        return applications;
      }
    }
  }

  getTimesFromZoneAllShifts(applications) {
    var _this = this;

    var tempTimeArray = [];

    var tempTimeObj = null;

    try {
      applications.forEach(function (application) {
        application.jobble.shifts.forEach(function (shift) {
          console.log("each shift");
          console.dir(shift);
        });

        /*
				tempTimeObj = {};
				
				if (application.currentShift.checkInTime) {
					tempTimeObj.start_time = moment(application.currentShift.checkInTime).tz(application.currentShift.contactInfo.place.timeZoneId).format("hh:mm A");
				
				}
				
				if (application.currentShift.checkOutTime) {
					tempTimeObj.end_time = moment(application.currentShift.checkOutTime).tz(application.currentShift.contactInfo.place.timeZoneId).format("hh:mm A");
				}
				
				application.currentShift.checkInAndOutForDisplay = tempTimeObj;
				*/
      });
    } finally {
      return applications;
    }
  }

  getClientDate(serverUTCTime) {
    var date = new Date(serverUTCTime);
    return moment(date).format("MMM DD, YYYY");
  }

  transferConnectionFee(cardToken) {
    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/charge-customer?format=json&amount=2500&note=Connection",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return this.$http(req);
  }

  bulkConnect(paymentInfo, jobbler) {
    //{"username":"elie.fossi2@gmail.com", "application":2, "freeOfCharge":true}

    if (paymentInfo.bankName) {
      var req = {
        method: "POST",
        url:
          this.$env.getAPIEndPoint() +
          "jbl/v1/companies/bulk-connect?format=json&amount=2500&custUsername=" +
          this.$localStorage.logged_user.username +
          "&note=Connection2",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
        },
        data: {
          usersAndApplications: [
            {
              username: jobbler.email,
              application: jobbler.applicationId,
            },
          ],
          bank: paymentInfo.stripeId,
          note: "Connection",
        },
      };
    } else {
      var req = {
        method: "POST",
        url:
          this.$env.getAPIEndPoint() +
          "jbl/v1/companies/bulk-connect?format=json&amount=2500&custUsername=" +
          this.$localStorage.logged_user.username +
          "&note=Connection2",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
        },
        data: {
          usersAndApplications: [
            {
              username: jobbler.email,
              application: jobbler.applicationId,
            },
          ],
          card: paymentInfo.cardToken,
          note: "Connection",
        },
      };
    }

    return this.$http(req);
  }

  getUserLatestWorkHistory(userId) {
    var _this = this;

    let url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + userId + "/history";

    var req = {
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return this.$http(req);
  }

  getInvoice(invoiceId, eventId) {
    var _this = this;

    var url = null;

    if (eventId) {
      url =
        _this.$env.getAPIEndPoint() +
        "jbl/v1/payments?format=json&max=100&eventId=" +
        eventId +
        "&fields=dateCreated,id,event.id,notePayer,detailTransactionCompany,payedUser.firstName,payedUser.lastName,jobble.id,jobble.payPerHour,amount,amountCompany,jobble.actualMinutesWorked,jobble.jobbleDuration,confirmation,payingUser.id,payingUser.firstName,payingUser.lastName,payingCompany.name";
    } else {
      url =
        _this.$env.getAPIEndPoint() +
        "jbl/v1/payments/" +
        invoiceId +
        "?format=json&max=1&fields=dateCreated,id,event.id,notePayer,detailTransactionCompany,payedUser.firstName,payedUser.lastName,jobble.id,jobble.payPerHour,amount,amountCompany,jobble.actualMinutesWorked,jobble.jobbleDuration,confirmation,payingUser.id,payingUser.firstName,payingUser.lastName,payingCompany.name";
    }

    var req = {
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return this.$http(req);
  }

  sendMicroDeposit(a1, a2, bank_token, setupId) {
    var _this = this;

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/validate-bank-account?format=json&conf=web&bankAccount=" + bank_token,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {amount1: a1, amount2: a2},
    };

    return this.$http(req);
  }

  putActualMinutesWorked(jobbleId, minutes, rev) {
    var _this = this;

    var req = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbleId + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {
        actualMinutesWorked: minutes,
        actualRevenue: rev,
      },
    };

    return this.$http(req);
  }

  putPayPerHourUpdateForDelivery(jobble_id, amount) {
    var _this = this;

    let data = {};
    data.payPerHour = amount;
    var req = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "?format=json&conf=web&fields=id,payPerHour",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: data,
    };
    return this.$http(req);
  }

  putActualMinutesWorkedTrimmed(jobbleId, minutes, rev) {
    var _this = this;
    let data = {};
    data.actualMinutesWorked = minutes;
    var req = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbleId + "?format=json&conf=web&fields=id,actualMinutesWorked,actualRevenue",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: data,
    };
    return this.$http(req);
  }

  putActualMinutesWorkedForShift(shiftId, minutes) {
    var _this = this;

    var req = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shiftId + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {
        actualMinutesWorked: minutes,
      },
    };

    return this.$http(req);
  }

  putActualMinutesWorkedForShiftTrimmed(shiftId, minutes) {
    var _this = this;

    var req = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shiftId + "?format=json&conf=web&fields=id,actualMinutesWorked",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {
        actualMinutesWorked: minutes,
      },
    };

    return this.$http(req);
  }

  markJobblerAsNoShow(data) {
    var _this = this;

    var req = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.jobbleId + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {noShow: true},
    };

    return _this.$http(req);
  }

  markJobblerAsNoShowTrimmed(data) {
    var _this = this;

    var req = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.jobble.id + "?format=json&fields=id",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {noShow: true},
    };
    return _this.$http(req);
  }

  markJobblerAsPaidByShiftTrimmed(data) {
    var _this = this;

    var req = {
      method: "PUT",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles/" +
        data.jobble.id +
        "?format=json&fields=id,makeAdditionalPayment,actualMinutesWorked,jobbleDurationInMinutes,actualRevenue,costOfJobble",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {makeAdditionalPayment: true},
    };

    return _this.$http(req);
  }

  markJobblerAsPaidByShiftTrimmedCancel(data) {
    var _this = this;

    var req = {
      method: "PUT",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles/" +
        data.jobble.id +
        "?format=json&fields=id,makeAdditionalPayment,actualMinutesWorked,jobbleDurationInMinutes,actualRevenue,costOfJobble",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {makeAdditionalPayment: false},
    };

    return _this.$http(req);
  }

  markJobblerAsNoShowCancel(data) {
    var _this = this;

    console.log("what is the data in cancel?");
    console.dir(data);

    var req = {
      method: "PUT",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles/" +
        data.jobble.id +
        "?format=json&conf=web&fields=id,jobbleDurationInMinutes,actualRevenue,startTime,endTime,shifts.id,shifts.paymentStats",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {noShow: null},
    };

    return _this.$http(req);
  }

  getConnections(id, offset) {
    var _this = this;

    if (!offset) {
      offset = 0;
    }

    var url = _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + id + "/users?format=json&conf=web&sort=email&order=asc&max=100&offset=" + offset;

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  getJobbler(id, offset) {
    var _this = this;

    if (!offset) {
      offset = 0;
    }

    var url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + id + "/?format=json&conf=web";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  getJobblerStars(jobbler) {
    var _this = this;

    var rating = "";
    if (jobbler.averageRatingReceived) {
      if (Math.round(jobbler.averageRatingReceived) === 0) {
        rating = "one";
      }
      if (Math.round(jobbler.averageRatingReceived) === 1) {
        rating = "one";
      }
      if (Math.round(jobbler.averageRatingReceived) === 2) {
        rating = "two";
      }
      if (Math.round(jobbler.averageRatingReceived) === 3) {
        rating = "three";
      }
      if (Math.round(jobbler.averageRatingReceived) === 4) {
        rating = "four";
      }
      if (Math.round(jobbler.averageRatingReceived) === 5) {
        rating = "five";
      }
    } else {
      rating = "five";
    }
    return rating;
  }

  getToken(data) {
    var _this = this;

    let req = {
      method: "POST",
      url: "https://api.stripe.com/v1/tokens",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + _this.$env.EnvironmentConfig.stripeKey,
      },
      data: _this.$httpParamSerializerJQLike(data),
    };

    return _this.$http(req);
  }

  saveRecipient(data) {
    var _this = this;

    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/create-recipient-stripe-account?format=json&conf=web&typeAccount=individual",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {
        paymentMethod: data.paymentMethod,
        stripeToken: data.stripeToken,
        username: data.username,
        country: data.country,
        currency: data.currency,
      },
    };
    return _this.$http(req);
  }

  detectDevice() {
    var _this = this;

    let data = {};
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      if (/iPhone/.test(navigator.userAgent)) {
        data.mobile_device_type = "iPhone";
        data.user_agent = navigator.userAgent;
      } else if (/Android/.test(navigator.userAgent)) {
        data.mobile_device_type = "Android";
        data.user_agent = navigator.userAgent;
      } else if (/iPad/.test(navigator.userAgent)) {
        data.mobile_device_type = "iPad";
        data.user_agent = navigator.userAgent;
      } else if (/Blackberry/.test(navigator.userAgent)) {
        data.mobile_device_type = "Blackberry";
        data.user_agent = navigator.userAgent;
      } else {
        data.mobile_device_type = "Other";
        data.user_agent = navigator.userAgent;
      }
    } else {
      data.mobile_device_type = "Desktop";
      data.user_agent = navigator.userAgent;
    }
    return data;
  }

  getReferenceQuestions() {
    var _this = this;

    var req = {
      method: "GET",
      url: _this.$env.getAPIEndPoint() + "public/userReferences/questions?config=web&format=json",
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    };

    return this.$http(req);
  }

  getReferenceDataFromAPI(rid) {
    var _this = this;

    var req = {
      method: "GET",
      url: _this.$env.getAPIEndPoint() + "public/userReferences/references/" + rid + "?config=web&format=json",
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    };

    return this.$http(req);
  }

  findQuestionId(searchString, questions) {

    let questionIndex = questions.findIndex(element => element.name.includes(searchString));

    return questions[questionIndex].id;
  }

  saveReferenceQuestion(d) {

    var _this = this;

    console.log("saveReferenceQuestion");
    console.dir(d);

    let payload = {
      answers: [
        {
          answer: d.answer,
          questionId: d.questionId
        },
      ],
    };

    if (d.status === "COMPLETED") {
      payload.answers[0].status = "COMPLETED";
    }

    let data = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "/public/userReferences/references/" + d.userReferenceId + "/responses?config=web&format=json",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    };

    return _this.$http(data);
  }
}

SecurityService.$inject = ["$http", "$localStorage", "$state", "env", "$rootScope", "$httpParamSerializerJQLike"];



// WEBPACK FOOTER //
// ./client/app/services/security.js